// extracted by mini-css-extract-plugin
export default {"signUpButton":"_5Ty_ueZrrH6Fvo3HUETB0","text":"_3RTUO_w7STQ2wrzTuo-lra","link":"_2Rpvwf1N2zJP2eIbrT59jm"};